<template>
  <div>
    <div style="margin-bottom:20px;">
      <Input v-model="searchCont" placeholder="请输入公式编号或公司名称" clearable style="width: 200px;" />
      <Button type="primary" size="default" @click="searchHandler" style=" margin-left :10px;">查询</Button>
      <Button
        type="primary"
        size="default"
        @click="newNustomer"
        style=" margin:4px 30px 0 0; float:right;"
      >新建</Button>
    </div>
    <div class="demo-spin-container">
      <Table
        border
        ref="selection"
        :columns="columns12"
        :data="data6"
        @on-selection-change="changeSelection"
      >
        <template slot-scope="{ row }" slot="name">
          <strong>{{ row.name }}</strong>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Button type="primary" size="small" style="margin-right: 5px" @click="show(row)">编辑</Button>
          <Button type="error" size="small" @click="remove(index)">删除</Button>
        </template>
      </Table>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
    <Page
        class="pageBox"
        style="margin-top: 30px;text-align: center"
        :total="pageTotal"
        :current="page"
        :page-size="limit"
        @on-change="changePage"
      />
    <div>
      <Modal v-model="modal1" width="360">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>删除</span>
        </p>
        <div style="text-align:center">
          <p>是否要删除{{this.name}}</p>
        </div>
        <div slot="footer">
          <Button type="error" size="large" long :loading="modal_loading" @click="del">确认</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script type='es6'>
import api from "@/api/api";
export default {
  data() {
    return {
      pageTotal: 10, // 数据总条数
      page: 1, // 页码
      limit: 10, // 每页显示条数
      modal1: false,
      modal_loading: false,
      spinShow: true,
      modal3: false,
      name: "",
      formLeft: {
        roleName: ""
      },
      roleList: [],
      id: "",
      searchCont: "",
      columns12: [
        {
          title: "编号",
          key: "id",
          align: "center",
          // render: (h, params) => {
          //   return h("span", (this.page - 1) * this.limit + params.index + 1);
          // }
        },
        {
          title: "公式名称",
          key: "formulaName",
          align: "center"
        },
        {
          title: "公式编号",
          key: "formulaNum",
          align: "center"
        },
        {
          title: "表达式",
          key: "formulaExpression",
          align: "center"
        },
        {
          title: "单位",
          key: "formulaUnit",
          align: "center"
        },
        {
          title: "共享",
          // key: "isPublic",
          align: "center",
          render: (h, { row }) => {
            return h("div", row.isPublic == 1 ? "是" : "否");
          }
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center",
          
        }
      ],
      data6: [],
      selectionId: [], // 选中的id集合
      isSearchMore: true,
      menuIdList: [],
      listRoleMenu: [],
      roleId: ""
    };
  },
  methods: {
    //编辑显示的页面
    show(row) {
      //
      this.$router.push({
        path: `/multilevel/formula_properties/${row.id}`,
        query:{
          row:row
        }
      });
    },
    // // 复选框选中内容
    // changeSelection(selection) {
    //   this.selectionId = [];
    //   selection.map(item => {
    //     this.selectionId.push(item.id);
    //   });
    // },
    // //批量删除
    // delData(e, id) {
    //   let ids = [];
    //   if (id) {
    //     // 删除一个
    //     ids.push(id);
    //   } else {
    //     // 删除选中的所有
    //     if (this.selectionId.length > 0) {
    //       ids = this.selectionId;
    //     } else {
    //       this.$Message.error("没有要删除的角色");
    //     }
    //   }

    //   api.sysDeleteRoleById(ids).then(res => {
    //     if (res.data.code === 0) {
    //       this.$Message.success("删除成功");
    //       this.getData();
    //     } else {
    //       this.$Message.success(res.data.msg);
    //     }
    //   });
    // },
    del() {
      this.modal_loading = true;
      let id = this.data6[this.id].id;
      api.deleteFormulaExpressionById([(this.id = id)]).then(res => {
        if (res.data.code === 0) {
          setTimeout(() => {
            this.modal_loading = false;
            this.modal1 = false;
            this.$Message.success("删除成功");
            this.getData();
          }, 2000);
        } else {
          setTimeout(() => {
            this.modal_loading = false;
            this.modal1 = false;
            this.$Message.success(res.data.msg);
            this.getData();
          }, 1000);
        }
      });
    },
    remove(index) {
      this.modal1 = true;
      this.id = index;
      this.name = this.data6[index].formulaName;
    },
    //新建显示的页面
    newNustomer() {
      this.$router.push({
        path: `/multilevel/new_formula`
      });
    },
    // 获取页面数据
    getData() {
      api.queryFormulaExpressionist({ keyword: this.searchCont== "" ? "" : this.searchCont, limit : this.limit , page : this.page }).then(res => {
        let data = res.data;
       
        if (data.code === 0) {
            this.data6 = data["page"]["list"];
            this.pageTotal = data["page"]["totalCount"];
            if(this.data6 == ""){
              this.spinShow = false
            }else{
              this.spinShow = false
            }
        } else {
          this.$Message.error(data.msg);
        }
      });

    },
    getData1() {
      api.queryFormulaExpressionist({ keyword: this.searchCont== "" ? "" : this.searchCont, limit : this.limit , page : this.page }).then(res => {
        let data = res.data;
       
        if (data.code === 0) {
            this.data6 = data["page"]["list"];
            this.pageTotal = data["page"]["totalCount"];
            if(this.data6 == ""){
              this.$Message.success("搜索不到该租户");
              this.spinShow = false
            }else{
              this.spinShow = false
              this.$Message.success("搜索成功");
            }
        } else {
          this.$Message.error(data.msg);
        }
      });

    },
    // 复选框选中内容
    changeSelection(selection) {
      this.selectionId = [];
      selection.map(item => {
        this.selectionId.push(item.roleId);
      });
    },
    // 删除

    // 搜索
    searchHandler() {
      this.getData1();
    },
    changePage(val) {
      this.page = val;
    }
  },
  created() {
    this.getData();
  },
  watch: {
    page: {
      handler() {
        this.getData();
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.demo-spin-container {
  display: inline-block; 
  width: 100%;
  /* height: 100%; */
  position: relative;
  /* border: 1px solid #eee; */
}
</style>